export default function Loading() {
  // You can add any UI inside Loading, including a Skeleton.
  return (
    <>
      <LoadingUi className="h-[20vh]" />
    </>
  );
}

export const LoadingUi = ({ className }: { className: string }) => (
  <div
    className={`relative mx-auto flex w-auto items-center justify-center ${className}`}
  >
    <img
      src={"/images/loader.gif"}
      alt=""
      height={100}
      width={100}
      className="rounded-[15px]"
    />
  </div>
);
